import Config from '../../../config';

import {
  FETCH_BATCH_PROVISIONS_CONNECTIONS_SUCCESS,
  FETCH_BATCH_PROVISIONS_CONNECTIONS_FAILURE,
  SELECT_CONNECTION_FOR_BATCH_PROVISIONS,
  FETCH_BATCH_PROVISIONS_SUCCESS,
  FETCH_BATCH_PROVISIONS_FAILURE,
  FETCH_BATCH_PROVISIONS,
  SET_PROCESSED_SUCCESSFULLY_FILTER,
  UNSET_PROCESSED_SUCCESSFULLY_FILTER,
  SET_TRIAL_BALANCES_NOT_RECEIVED_FILTER,
  SET_TRIAL_BALANCES_WITH_ERRORS_FILTER,
  UNSET_TRIAL_BALANCES_WITH_ERRORS_FILTER,
  UNSET_TRIAL_BALANCES_NOT_RECEIVED_FILTER,
  SET_CALCULATION_ERRORS_FILTER,
  UNSET_CALCULATION_ERRORS_FILTER,
  SET_JOURNALS_FILTER,
  UNSET_JOURNALS_FILTER,
  SET_LOCAL_JOURNALS_FILTER,
  UNSET_LOCAL_JOURNALS_FILTER,
  INITIATE_CALC,
  INITIATE_CALC_FAILURE,
  INITIATE_CALC_SUCCESS,
  UPDATE_CONNECTION_STATUS,
  FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION_SUCCESS,
  FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION_FAILURE,
  FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION,
} from './types';

import {
  statusBadgeMessages,
  connectionStatuses,
} from '../../../shared/constants';

import {
  selectPeriod,
  fetchConnections,
  showAlert,
  fetchingError,
  fetchProvisions as fetchHomePageProvisions,
} from '../../../shared/store/actions';

import alertTypes from '../../../shared/alertTypes';
import { errorNotification, successNotification } from '../../../shared/store/notificationActions';
import {
  fetchBatchProvisions as fetchBatchProvisionsApi,
  fetchBatchProvisionsConnections as fetchBatchProvisionsConnectionsApi,
  processBatchProvisionsForGlUIConnection as processBatchProvisionsForGlUIConnectionApi,
  processBatchProvisionsForFTPConnection as processBatchProvisionsForFTPConnectionApi,
} from '../api';

import getModalActions from '../../../shared/modals/getModalActions';
import { ModalNames } from '../../constants';

import {
  fetchCompanyCodesForSelectedConnection as fetchCompanyCodesForSelectedConnectionApi,
} from '../../../administration/beginningBalancesPage/api';
import { addJob } from '../../../shared/jim/store/actions';

export const fetchBatchProvisions = () => async (dispatch, getState) => {
  const { shared, provision: { batchProvisions } } = getState();
  if (batchProvisions.isFetching || !batchProvisions.connection) {
    return;
  }

  const periodName = shared.period.name;
  const connectionName = batchProvisions.connection.connName;

  try {
    dispatch({
      type: FETCH_BATCH_PROVISIONS,
    });

    const batchProvisions = await fetchBatchProvisionsApi(periodName, connectionName);

    return dispatch({
      type: FETCH_BATCH_PROVISIONS_SUCCESS,
      batchProvisions,
    });
  } catch (error) {
    dispatch({
      type: FETCH_BATCH_PROVISIONS_FAILURE,
    });
    return dispatch(errorNotification(error.message));
  }
};

const fetchBatchProvisionsConnections = period => async dispatch => {
  try {
    const response = await fetchBatchProvisionsConnectionsApi(period.name);

    return dispatch({
      type: FETCH_BATCH_PROVISIONS_CONNECTIONS_SUCCESS,
      connections: response,
    });
  } catch (error) {
    dispatch({
      type: FETCH_BATCH_PROVISIONS_CONNECTIONS_FAILURE,
    });
    return dispatch(errorNotification(error.message));
  }
};

export const fetchCompanyCodesForSelectedConnection = connection => async dispatch => {
  dispatch({
    type: FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION,
  });

  try {
    const [
      companyCodesForConnection,
    ] = await Promise.all([
      fetchCompanyCodesForSelectedConnectionApi(connection),
    ]);

    return dispatch({
      type: FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION_SUCCESS,
      companyCodesForConnection,
    });
  } catch (error) {
    dispatch({
      type: FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const selectConnectionForBatchProvisions = connName =>
  async (dispatch, getState) => {
    const { provision: { batchProvisions } } = getState();
    const connections = batchProvisions.connections;

    const connection = connections.find(connection => connection.connName === connName);

    dispatch({
      type: SELECT_CONNECTION_FOR_BATCH_PROVISIONS,
      connection,
    });
    dispatch(fetchCompanyCodesForSelectedConnection(connName));
    return dispatch(fetchBatchProvisions());
  };

export const selectPeriodForBatchProvisions = period => async dispatch => {
  dispatch(selectPeriod(period));

  await dispatch(fetchBatchProvisionsConnections(period));

  await dispatch(fetchConnections(period, {
    includeAllOption: false,
  }));

  return dispatch(fetchBatchProvisions());
};

export const fetchInitialDataForBatchProvisions = () => async (dispatch, getState) => {
  const { period } = getState().shared;

  return dispatch(fetchBatchProvisionsConnections(period));
};

export const updateConnectionStatus = ({
  connStatus,
  connStatusName,
}) => ({
  type: UPDATE_CONNECTION_STATUS,
  connStatus,
  connStatusName,
});

export const processBatchProvisions = ({
  file,
  period,
  connection,
  calculateProvisions,
  loadTrialBalances,
  skipFileUpload,
}) => async dispatch => {
  if (!calculateProvisions && !loadTrialBalances) {
    return dispatch(errorNotification(
      'You must select either the Load Trial Balance or Calculate Provisions option.',
      {
        timeOut: 0,
        showCloseButton: true,
        removeOnHover: false,
      }
    ));
  }

  dispatch(updateConnectionStatus({
    connStatus: connectionStatuses.PROCESSING,
    connStatusName: statusBadgeMessages.PROCESSING,
  }));


  await dispatch(
    addJob({
      jobType: Config.jimJobs.batchProvisionsImport.type,
      payload: {
        file,
        connectionName: connection.connName,
        periodName: period.name,
        calculateProvisions,
        loadTrialBalances,
        skipFileUpload,
      },
    }));
};

// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated GlUI connections are not used anymore
 */
export const processBatchProvisionsForGlUIConnection = ({
  period,
  connection,
  ledgers,
}) => async dispatch => {
  // processBatchProvisionsForGlUIConnection action is deprecated and will be removed
  const failureAction = {
    type: INITIATE_CALC_FAILURE,
  };

  try {
    dispatch({
      type: INITIATE_CALC,
    });

    const integrationStatus = await processBatchProvisionsForGlUIConnectionApi({
      periodName: period.name,
      connectionName: connection.connName,
      ledgers,
    });

    if (integrationStatus.status === 1) {
      dispatch({
        type: INITIATE_CALC_SUCCESS,
      });
      return dispatch(fetchBatchProvisions());
    }

    if (integrationStatus.status === -1) {
      dispatch(showAlert('An error occurred importing the file. The period is invalid.', alertTypes.DANGER));
    }

    if (integrationStatus.status === -2) {
      dispatch(showAlert('An error occurred importing the file. The connection is invalid.', alertTypes.DANGER));
    }

    return dispatch(failureAction);
  } catch (error) {
    dispatch(failureAction);
    return dispatch(errorNotification(error.message));
  }
};

export const processBatchProvisionsForFTPConnection = ({
  period,
  connection,
  proformaCalc,
}) => async dispatch => {
  if (!proformaCalc) {
    return dispatch(errorNotification(
      'You must select the Proforma Calculation option.',
      {
        timeOut: 0,
        showCloseButton: true,
        removeOnHover: false,
      }
    ));
  }

  const failureAction = {
    type: INITIATE_CALC_FAILURE,
  };

  try {
    dispatch({
      type: INITIATE_CALC,
    });

    const integrationStatus = await processBatchProvisionsForFTPConnectionApi({
      periodName: period.name,
      connName: connection.connName,
    });

    if (integrationStatus.retVal === '1') {
      dispatch({
        type: INITIATE_CALC_SUCCESS,
      });
      dispatch(successNotification('Proforma Provisions Successfully Calculated'));
      return dispatch(fetchBatchProvisions());
    }

    return dispatch(failureAction);
  } catch (error) {
    dispatch(failureAction);
    return dispatch(errorNotification(error.message));
  }
};

export const setProcessedSuccessfullyFilter = filter => ({
  type: SET_PROCESSED_SUCCESSFULLY_FILTER,
  filter,
});

export const unsetProcessedSuccessfullyFilter = () => ({
  type: UNSET_PROCESSED_SUCCESSFULLY_FILTER,
});

export const setTrialBalancesNotReceivedFilter = filter => ({
  type: SET_TRIAL_BALANCES_NOT_RECEIVED_FILTER,
  filter,
});

export const unsetTrialBalancesNotReceivedFilter = () => ({
  type: UNSET_TRIAL_BALANCES_NOT_RECEIVED_FILTER,
});

export const setTrialBalancesWithErrorsFilter = filter => ({
  type: SET_TRIAL_BALANCES_WITH_ERRORS_FILTER,
  filter,
});

export const unsetTrialBalancesWithErrorsFilter = () => ({
  type: UNSET_TRIAL_BALANCES_WITH_ERRORS_FILTER,
});

export const setCalculationErrorsFilter = filter => ({
  type: SET_CALCULATION_ERRORS_FILTER,
  filter,
});

export const unsetCalculationErrorsFilter = () => ({
  type: UNSET_CALCULATION_ERRORS_FILTER,
});

export const setJournalsFilter = filter => ({
  type: SET_JOURNALS_FILTER,
  filter,
});

export const unsetJournalsFilter = () => ({
  type: UNSET_JOURNALS_FILTER,
});

export const setLocalJournalsFilter = filter => ({
  type: SET_LOCAL_JOURNALS_FILTER,
  filter,
});

export const unsetLocalJournalsFilter = () => ({
  type: UNSET_LOCAL_JOURNALS_FILTER,
});

export const {
  showAction: showCannotBeginProcessingModal,
  hideAction: hideCannotBeginProcessingModal,
} = getModalActions(ModalNames.CannotBeginProcessingMessage);


export const refreshStatus = ({ period }) => async dispatch => {
  dispatch(fetchBatchProvisions());
  dispatch(fetchHomePageProvisions(period));
};
